import { create } from 'zustand';
import { createLogger } from '../utils/logger';

const log = createLogger('TableStore');

export interface TableState {
  sortColumn: string;
  sortDirection: 'asc' | 'desc';
  highlightedStationCode: string | null;
  scrollToStationCode: string | null;
}

export interface TableActions {
  /** Toggle sort direction on a column (or switch to asc on a new column) */
  setSort: (column: string) => void;
  /** Alias for setSort — matches legacy appStore.sortTable interface */
  sortTable: (column: string) => void;
  highlightRow: (stationCode: string | null) => void;
  setScrollToStation: (stationCode: string | null) => void;
  clearScrollToStation: () => void;
}

export type TableStore = TableState & TableActions;

export const useTableStore = create<TableStore>((set, get) => ({
  // State
  sortColumn: 'stationCode',
  sortDirection: 'asc',
  highlightedStationCode: null,
  scrollToStationCode: null,

  // Actions
  setSort: (column) => {
    const { sortColumn, sortDirection } = get();
    const newDirection =
      sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    set({ sortColumn: column, sortDirection: newDirection });
    log.debug(`🔄 Sorted table: ${column} ${newDirection}`);
  },

  sortTable: (column) => {
    // ponytail: alias — delegates to setSort for backward compat
    get().setSort(column);
  },

  highlightRow: (stationCode) => {
    set({ highlightedStationCode: stationCode });
  },

  setScrollToStation: (stationCode) => {
    set({ scrollToStationCode: stationCode });
  },

  clearScrollToStation: () => {
    set({ scrollToStationCode: null });
  },
}));
